import { useAtomValue } from 'jotai';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { unwrappedPitchVisDisplayPresetsAtom } from '@/atoms/queries/pitchVisDisplayPresets';
import { getMetricPitchConfig, PITCH_PRESET_PARAM_KEYS, PitchVisDisplaySettings } from '@/consts/metricPitchConfig';
import { METRIC_KEY } from '@/consts/searchKeys';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';

export const useMetricPitchPresetNavigation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const pitchVisDisplayPresets = useAtomValue(unwrappedPitchVisDisplayPresetsAtom);
  const createQueryString = useUpdateQueryString(searchParams);

  return (metricKey: string) => {
    const presetName = pitchVisDisplayPresets.get(metricKey);
    const config = getMetricPitchConfig(presetName);

    const presetParams = (Object.entries(PITCH_PRESET_PARAM_KEYS) as [keyof PitchVisDisplaySettings, string][]).map(
      ([field, paramKey]) => ({ key: paramKey, value: String(config[field]) }),
    );

    navigate(`?${createQueryString([{ key: METRIC_KEY, value: metricKey }, ...presetParams])}`);
  };
};
